//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'switchStatus',
  props: {
    value: {
      default: true,
      type: Boolean
    },
    activeText: {
      default: undefined,
      type: String
    },
    inactiveText: {
      default: undefined,
      type: String
    },
    name: {
      default: undefined,
      type: String
    }
  },
  data: function data() {
    return {
      internalValue: this.value
    };
  },
  methods: {}
};